import { useEffect, useState } from "react";
import { AxiosPublico } from "../../../../componentes/axios/Axios";
import Card from "../../../../componentes/contenedores/Card";
import Linea from "../../../../componentes/graficos/Lineal3";
import Page from "../../../../componentes/plantilla/Page";
import { HistorialesActuadoresListar } from "../../../../configuracion/apiUrls";

const coloresActuadores = {
    "Focos": "#FFCE56",
    "Bombas": "#36A2EB",
    "Ventiladores": "#4BC0C0",
};

const obtenerFechasDeFiltro = (filtro, fechaSeleccionada, horaSeleccionada, semanaSeleccionada, mesSeleccionado, anioSeleccionado) => {
    let fechaInicio, fechaFin;
    const [year, month, day] = fechaSeleccionada.split('-').map(Number);

    switch (filtro) {
        case "dia":
            fechaInicio = new Date(year, month - 1, day);
            fechaFin = new Date(year, month - 1, day + 1);
            break;
        case "dia-hora":
            const [hour, minute] = horaSeleccionada.split(':').map(Number);
            fechaInicio = new Date(year, month - 1, day, hour, minute);
            fechaFin = new Date(fechaInicio.getTime() + 60 * 60 * 1000);
            break;
        case "semana":
            const [yearWeek, week] = semanaSeleccionada.split('-W').map(Number);
            const primerDiaDelAnio = new Date(yearWeek, 0, 1);
            const diaDeLaSemanaPrimerDia = primerDiaDelAnio.getDay();
            const ajusteAlLunes = diaDeLaSemanaPrimerDia === 0 ? 1 : 8 - diaDeLaSemanaPrimerDia;
            fechaInicio = new Date(primerDiaDelAnio.getFullYear(), 0, 1 + ajusteAlLunes + (week - 1) * 7);
            fechaFin = new Date(fechaInicio);
            fechaFin.setDate(fechaFin.getDate() + 7);
            break;
        case "mes":
            const [mesAnio, mes] = mesSeleccionado.split('-').map(Number);
            fechaInicio = new Date(mesAnio, mes - 1, 1);
            fechaFin = new Date(mesAnio, mes, 1);
            break;
        case "año":
            const anio = parseInt(anioSeleccionado);
            fechaInicio = new Date(anio, 0, 1);
            fechaFin = new Date(anio + 1, 0, 1);
            break;
        default:
            fechaInicio = null;
            fechaFin = null;
            break;
    }
    return { fechaInicio, fechaFin };
};

const formatearDatos = (datos, tipoActuador) => {
    const filtrado = datos.filter(
        d => d.fechaActivacion && d.tiempoActivacionSegundos !== null
    );

    // Mapeamos las etiquetas (eje X) usando `fechaActivacion`
    const labels = filtrado.map(d =>
        new Date(d.fechaActivacion).toLocaleTimeString([], {
            hour: "2-digit", minute: "2-digit", second: "2-digit"
        })
    );

    // Mapeamos los datos de la serie (eje Y) usando `tiempoActivacionSegundos`
    const dataValues = filtrado.map(d => d.tiempoActivacionSegundos);

    // Creamos el objeto completo para la gráfica
    const chartData = {
        labels: labels,
        datasets: [{
            label: `Duración de ${tipoActuador} (s)`,
            data: dataValues,
            borderColor: coloresActuadores[tipoActuador] || "#9966FF",
            backgroundColor: coloresActuadores[tipoActuador] || "#9966FF",
            fill: false,
            tension: 0.3,
            pointRadius: 3,
            pointHoverRadius: 5,
        }],
    };

    return {
        ...chartData,
        raw: filtrado,
        titulo: `Tiempo de Activación de ${tipoActuador}`,
        tipo: "actuador",
    };
};

const ResumenActuador = ({ datos }) => {
    const valores = datos.raw;
    if (valores.length === 0) return <p>No hay datos para mostrar</p>;

    const activaciones = valores.filter(v => v.estado === "Activado").length;
    const desactivaciones = valores.filter(v => v.estado === "Desactivado").length;
    const ultimo = valores[valores.length - 1];

    const duracionTotal = valores.reduce((sum, d) => sum + d.tiempoActivacionSegundos, 0);
    const duracionPromedio = valores.length > 0 ? duracionTotal / valores.length : 0;

    return (
        <div className="card shadow-sm mb-4">
            <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="card-title fw-semibold mb-0">Resumen de Datos</h6>
                    <h6 className="fw-bold mb-0">Actuador: {ultimo.actuador.nombre}</h6>
                </div>
                <div className="table-responsive">
                    <table className="table table-sm table-striped table-bordered mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Dato</th>
                                <th>Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Último Estado</td>
                                <td>{ultimo.estado}</td>
                            </tr>
                            <tr>
                                <td>Activaciones</td>
                                <td>{activaciones}</td>
                            </tr>
                            <tr>
                                <td>Desactivaciones</td>
                                <td>{desactivaciones}</td>
                            </tr>
                            <tr>
                                <td>Duración Total (s)</td>
                                <td>{duracionTotal.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Duración Promedio (s)</td>
                                <td>{duracionPromedio.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>Última Hora</td>
                                <td>{new Date(ultimo.fechaActivacion || ultimo.fechaDesactivacion).toLocaleTimeString()}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

const HomeActuadores = () => {
    const [cargando, setCargando] = useState(true);
    const [graficos, setGraficos] = useState([]);
    const [nombreInvernadero, setNombreInvernadero] = useState("");

    const [filtro, setFiltro] = useState("dia");
    const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date().toLocaleDateString('en-CA'));
    const [horaSeleccionada, setHoraSeleccionada] = useState(new Date().toTimeString().split(' ')[0].slice(0, 5));
    const [semanaSeleccionada, setSemanaSeleccionada] = useState("");
    const [mesSeleccionado, setMesSeleccionado] = useState(new Date().toISOString().slice(0, 7));
    const [anioSeleccionado, setAnioSeleccionado] = useState(new Date().getFullYear());

    const fetchDatos = async () => {
        setCargando(true);
        try {
            const invernaderoId = localStorage.getItem("invernaderoId");
            const nombre = localStorage.getItem("nombreInvernadero");
            if (nombre) setNombreInvernadero(nombre);

            const { fechaInicio, fechaFin } = obtenerFechasDeFiltro(filtro, fechaSeleccionada, horaSeleccionada, semanaSeleccionada, mesSeleccionado, anioSeleccionado);

            const params = {};
            if (fechaInicio instanceof Date && !isNaN(fechaInicio)) {
    params.fechaInicio = fechaInicio.toISOString();
}

if (fechaFin instanceof Date && !isNaN(fechaFin)) {
    params.fechaFin = fechaFin.toISOString();
}


            const res = await AxiosPublico.get(HistorialesActuadoresListar, { params });

            const datos = res.data.filter(d => d.actuador?.invernaderoId == invernaderoId);

            const agrupadoPorTipo = {};
            for (const item of datos) {
                const tipo = item.actuador?.tipo;
                if (tipo) {
                    if (!agrupadoPorTipo[tipo]) agrupadoPorTipo[tipo] = [];
                    agrupadoPorTipo[tipo].push(item);
                }
            }

            const resultados = Object.entries(agrupadoPorTipo).map(([tipo, registros]) =>
                formatearDatos(registros, tipo)
            );
            setGraficos(resultados);
        } catch (err) {
            console.error("Error al obtener historial de actuadores:", err);
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        fetchDatos();
    }, [filtro, fechaSeleccionada, horaSeleccionada, semanaSeleccionada, mesSeleccionado, anioSeleccionado]);

    const handleApplyFilter = () => {
        fetchDatos();
    };

    const datos = {
        titulo: {
            titulo: `Historial de Actuadores - ${nombreInvernadero || "Invernadero"}`,
            url: "/app/admin/invernaderos/",
            tituloUrl: "Menu Principal",
            nombreUrl: "Historial",
        },
    };

    return (
        <Page datos={datos}>
            <Card titulo="Historial de Activación y Desactivación de Actuadores (Gráficas)">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3 gap-2 px-2">
                    <label htmlFor="filtro" className="form-label mb-0 fw-semibold text-nowrap">
                        Filtro:
                    </label>
                    <div className="d-grid d-md-flex flex-wrap gap-2 w-100">
                        <div className="d-grid d-md-flex gap-2 mb-2 mb-md-0">
                            <button
                                className={`btn btn-sm mx-1 ${filtro === "dia" ? "btn-primary" : "btn-outline-primary"}`}
                                onClick={() => setFiltro("dia")}>Hoy</button>
                            <button
                                className={`btn btn-sm mx-1 ${filtro === "dia-hora" ? "btn-primary" : "btn-outline-primary"}`}
                                onClick={() => setFiltro("dia-hora")}>Por Hora</button>
                            <button
                                className={`btn btn-sm mx-1 ${filtro === "semana" ? "btn-primary" : "btn-outline-primary"}`}
                                onClick={() => setFiltro("semana")}>Última Semana</button>
                        </div>
                        <div className="d-grid d-md-flex gap-2">
                            <button
                                className={`btn btn-sm mx-1 ${filtro === "mes" ? "btn-primary" : "btn-outline-primary"}`}
                                onClick={() => setFiltro("mes")}>Último Mes</button>
                            <button
                                className={`btn btn-sm mx-1 ${filtro === "año" ? "btn-primary" : "btn-outline-primary"}`}
                                onClick={() => setFiltro("año")}>Último Año</button>
                        </div>
                    </div>
                </div>
                {(filtro === "dia" || filtro === "dia-hora") && (
                    <div className="row mb-3 gx-2 px-2 align-items-center">
                        <div className="col-12 col-md-auto">
                            <label htmlFor="fechaSelect" className="form-label mb-0 fw-semibold">Fecha:</label>
                        </div>
                        <div className="col-12 col-sm">
                            <input
                                type="date"
                                id="fechaSelect"
                                className="form-control form-control-sm"
                                style={{ width: "70%" }}
                                value={fechaSeleccionada}
                                onChange={(e) => setFechaSeleccionada(e.target.value)}
                            />
                        </div>
                        {filtro === "dia-hora" && (
                            <>
                                <div className="col-12 col-md-auto mt-2 mt-md-0">
                                    <label htmlFor="horaSelect" className="form-label mb-0 fw-semibold">Hora:</label>
                                </div>
                                <div className="col-12 col-sm">
                                    <input
                                        type="time"
                                        id="horaSelect"
                                        className="form-control form-control-sm"
                                        style={{ width: "50%" }}
                                        value={horaSeleccionada}
                                        onChange={(e) => setHoraSeleccionada(e.target.value)}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                )}
                {filtro === "semana" && (
                    <div className="row mb-3 gx-2 px-2 align-items-center">
                        <div className="col-12 col-md-auto">
                            <label htmlFor="semanaSelect" className="form-label mb-0 fw-semibold">Semana:</label>
                        </div>
                        <div className="col-12 col-sm">
                            <input
                                type="week"
                                id="semanaSelect"
                                className="form-control form-control-sm"
                                style={{ width: "50%" }}
                                value={semanaSeleccionada}
                                onChange={(e) => setSemanaSeleccionada(e.target.value)}
                            />
                        </div>
                    </div>
                )}
                {filtro === "mes" && (
                    <div className="row mb-3 gx-2 px-2 align-items-center">
                        <div className="col-12 col-md-auto">
                            <label htmlFor="mesSelect" className="form-label mb-0 fw-semibold">Mes:</label>
                        </div>
                        <div className="col-12 col-sm">
                            <input
                                type="month"
                                id="mesSelect"
                                className="form-control form-control-sm"
                                style={{ width: "50%" }}
                                value={mesSeleccionado}
                                onChange={(e) => setMesSeleccionado(e.target.value)}
                            />
                        </div>
                    </div>
                )}
                {filtro === "año" && (
                    <div className="row mb-3 gx-2 px-2 align-items-center">
                        <div className="col-12 col-md-auto">
                            <label htmlFor="anioSelect" className="form-label mb-0 fw-semibold">Año:</label>
                        </div>
                        <div className="col-12 col-sm">
                            <input
                                type="number"
                                id="anioSelect"
                                className="form-control form-control-sm"
                                style={{ width: "50%" }}
                                min="2000"
                                max={new Date().getFullYear()}
                                value={anioSeleccionado}
                                onChange={(e) => setAnioSeleccionado(e.target.value)}
                            />
                        </div>
                    </div>
                )}
                <div className="d-grid mb-3 px-2">
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={handleApplyFilter}>
                        Aplicar Filtros
                    </button>
                </div>
                {cargando ? (
                    <div className="d-flex justify-content-center align-items-center py-5">
                        <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status"></div>
                    </div>
                ) : (
                    <div className="row">
                        {graficos.length > 0 ? (
                            graficos.map((grafico, idx) => (
                                <div key={idx} className="col-12 mb-4">
                                    <h5 className="text-center">{grafico.titulo}</h5>
                                    <Linea datos={grafico} />
                                    <ResumenActuador datos={grafico} />
                                </div>
                            ))
                        ) : (
                            <p className="text-center py-5">No hay datos para mostrar con los filtros seleccionados.</p>
                        )}
                    </div>
                )}
            </Card>
        </Page>
    );
};

export default HomeActuadores;